import { useState, useCallback, useRef, useEffect } from 'react';
import { useDelayedCallback } from '../useDelayedCallback';
import { useCustomAnimationListener } from '../useCustomAnimationListener';

export const usePortraitImage = (showGameDetails = false) => {
    const [shouldUsePortraitImage, setShouldUsePortraitImage] = useState(!showGameDetails);
    const showGameDetailsRef = useRef(showGameDetails);

    useEffect(() => {
        showGameDetailsRef.current = showGameDetails;
    });

    const resetShouldUsePortraitImage = useCallback(() => {
        setShouldUsePortraitImage(!showGameDetails);
    }, [showGameDetails]);

    const delayedReset = useDelayedCallback(resetShouldUsePortraitImage, 500);
    const handleShowHideDetails = useCallback(() => {
        setShouldUsePortraitImage(false);

        delayedReset();
    }, [delayedReset]);

    useCustomAnimationListener('gamesInfoPopupShowHideDetails', handleShowHideDetails);

    return {
        shouldUsePortraitImage
    };
};
